import React from 'react';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { Show } from '../../components/shared/Show';
import { LabelTextTW } from './LabelTextTW';
import { ErrorTextTW } from './ErrorTextTW';
import { HintTextTW } from './HintTextTW';
import classNames from 'classnames';

export interface IFormCellTWProps extends IHasTestData {
  /** Additional CSS class. */
  className?: string;
  /** Message to display when the input is in an error state. When this is present, also visually highlights the component as in error. */
  errorText?: string;
  /** Hint text content. */
  hintText?: string;
  /** Highlights the input as a required field (does also perform additional validation). */
  isRequired?: boolean;
  /** This label appears above the input. */
  labelText?: string;
  /** all elements are disabled*/
  disabled?: boolean;
  name?: string;
  children?: React.ReactNode;
}

export const FormCellTW: React.FC<IFormCellTWProps> = ({
  labelText,
  errorText,
  hintText,
  isRequired,
  disabled,
  name,
  className,
  children,
}) => (
  <div className={classNames('mb-2', className)}>
    <Show when={!!labelText}>
      <LabelTextTW labelText={labelText} isError={!!errorText} isRequired={isRequired} name={name} />
    </Show>
    {children}
    <Show when={!!errorText} fallback={<HintTextTW hintText={hintText} disabled={disabled} />}>
      <ErrorTextTW errorText={errorText} />
    </Show>
  </div>
);
